module.exports = __webpack_public_path__ + "static/media/9bf383d9.jpg";